<template>
    <div>
        <v-dialog v-model="visible" transition="dialog-top-transition" scrollable persistent max-width="700">
            <v-card class="modal-maincard">

                <v-toolbar dark flat dense>
                    <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="wrapperFormModal">
                    <v-card flat>
                        <v-card-text>
                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{$t('Год')}}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <v-select
                                        v-model="year"
                                        :items="years"
                                        hide-details
                                        required
                                        outlined
                                        dense
                                        append-icon="fas fa-chevron-down"
                                        :menu-props="{ bottom: true, offsetY: true }"
                                    >
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{$t('Месяц')}}</label>
                                </v-col>
                                <v-col  cols="12" sm="12" md="9">
                                    <v-select
                                        v-model="month"
                                        :items="months"
                                        hide-details
                                        :item-text="item => $t(item.name)"
                                        item-value="id"
                                        required
                                        outlined
                                        dense
                                        return-object
                                        append-icon="fas fa-chevron-down"
                                        :menu-props="{ bottom: true, offsetY: true }"
                                    >
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>  
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                        v-if="year && month"
                        color="cyan" 
                        text 
                        depressed 
                        @click="ok" 
                        >
                        {{$t("Выбрать")}}
                    </v-btn>
                    <v-btn 
                        color="blue-grey" 
                        text
                        depressed 
                        @click="cancel"
                    >
                        {{$t("Отмена")}}
                    </v-btn>

                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "SelectMonthYearDlg",
    data () {
        return {
            title: "Выбор_периода",
            visible: false,
            resolve: null,
            reject: null,
            options: {
                color: 'grey lighten-3',
                width: 200,
                zIndex: 200,
                noconfirm: false,
            },
            year: null,
            month: null,
            years: [2025, 2026, 2027, 2028, 2029]
        }
    },
    computed: {
        ...mapGetters('documents/references', { months: 'GetMonths'})
    },
    methods: {
        async open(title = null)
        {
            if (title != null) 
                this.title = title;
            this.year = null;
            this.month = null;
            this.visible = true;
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        ok() {
            this.visible = false;
            this.resolve({ year: this.year, month: this.month });
        },
        cancel() {
            this.visible = false;
            this.reject({ message: "Выбор месяца/года отменён" });
        }
    }
}
</script>